// extracted by mini-css-extract-plugin
export var chevronIcon = "_ak-2";
export var teamName = "_ak-1";
export var teamSwitcherButton = "_ak-0";